export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photos de randonnées"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir les photos de nos randonneurs"])}
}